import { ICreateEventBlueprintDTO, IEventBlueprintDTO } from './event.blueprint.types';
import { BlueprintType, IBlueprintDTO, IOrderBookingBlueprintDTO } from './blueprint.types';
import { ICreateMeetingTemplateDTO, IMeetingTemplateDTO } from './meeting.template.types';
import { IConnectionTemplateDTO } from './connection.template.types';
import { ICreateOrderTemplateDTO, IOrderTemplateDetailsDTO, IOrderTemplateDTO } from './order.template.types';
import { IAssetUrlDTO, S3ObjectMetadata } from '../shared.dto';

abstract class IBlueprintsDAO {
    public abstract createBlueprint<T extends IBlueprintDTO, K extends IBlueprintDTO>(params: T): Promise<K>;
    public abstract editBlueprint<T extends IBlueprintDTO>(params: T): Promise<T>;
    public abstract getBlueprint<T extends IBlueprintDTO>(params: {accountId: number; blueprintId: string}): Promise<T>;
    public abstract deleteBlueprint(params: {accountId: number; blueprintId: string}) : Promise<void>;
    public abstract getEventBlueprintList(params: {accountId: number}): Promise<IEventBlueprintDTO[]>;
    public abstract getMeetingTemplateList(params: {accountId: number}): Promise<IMeetingTemplateDTO[]>;
    public abstract getConnectionTemplateList(params: {accountId: number}): Promise<IConnectionTemplateDTO[]>;
    public abstract getOrderTemplateList(params: {accountId: number}): Promise<IOrderTemplateDTO[]>;
    public abstract createOrderTemplate(params: ICreateOrderTemplateDTO): Promise<IOrderTemplateDetailsDTO>;
    public abstract getTempStorageSignedUrl(params: {accountId: number}): Promise<IAssetUrlDTO>;
    public abstract uploadFileToTempStorage(file: File, params: {accountId: number}): Promise<IAssetUrlDTO>;
    public abstract storeFileToStorage(params: { accountId: number } & S3ObjectMetadata): Promise<S3ObjectMetadata>;
    public abstract deleteFileFromStorage(params: {accountId: number; objectKey: string}): Promise<void>;
    public abstract updateOrderBookingBlueprintData(params: IOrderBookingBlueprintDTO): Promise<IEventBlueprintDTO>;
}

export {
    BlueprintType,
    IBlueprintsDAO,
    IEventBlueprintDTO,
    ICreateEventBlueprintDTO,
    IMeetingTemplateDTO,
    ICreateMeetingTemplateDTO,
    IOrderTemplateDTO,
    IOrderTemplateDetailsDTO,
    ICreateOrderTemplateDTO
};
